import { ENGLISH, FRENCH, SPANISH } from "kubra-labels";
import { LANGUAGE_MODAL_NAMESPACE, MENU_NAMESPACE } from "constants/i18n-namespaces";
import { IBiller } from "types/biller";

const DEFAULT_SUPPORTED_LANGUAGES = [ENGLISH, SPANISH, FRENCH];

const LANGUAGE_NAME_MAP: Record<string, string> = {
  "en-US": "English",
  "es-US": "Spanish",
  "fr-CA": "French",
};

const normalizeLanguageCode = (languageCode: string): string => {
  return languageCode?.trim() ?? "";
};

export const getSupportedLanguageCodes = (biller?: IBiller): string[] => {
  const supportedLanguages = biller?.space?.supportedLanguages
    ?.map((language) => normalizeLanguageCode(language.code))
    .filter((language) => language.length > 0);

  if (!supportedLanguages || supportedLanguages.length === 0) {
    return DEFAULT_SUPPORTED_LANGUAGES;
  }

  return supportedLanguages;
};

export const getLanguageLabel = (
  languageCode: string,
  context: "modal" | "menu",
  t: (key: string, options?: any) => string
): string => {
  const normalizedCode = normalizeLanguageCode(languageCode);

  if (
    normalizedCode === ENGLISH ||
    normalizedCode === SPANISH ||
    normalizedCode === FRENCH
  ) {
    if (context === "modal") {
      switch (normalizedCode) {
        case ENGLISH:
          return t("english", { ns: LANGUAGE_MODAL_NAMESPACE });
        case SPANISH:
          return t("spanish", { ns: LANGUAGE_MODAL_NAMESPACE });
        case FRENCH:
          return t("french", { ns: LANGUAGE_MODAL_NAMESPACE });
      }
    } else if (context === "menu") {
      switch (normalizedCode) {
        case ENGLISH:
          return t("eng", { ns: MENU_NAMESPACE });
        case SPANISH:
          return t("spa", { ns: MENU_NAMESPACE });
        case FRENCH:
          return t("fre", { ns: MENU_NAMESPACE });
      }
    }
  }

  return LANGUAGE_NAME_MAP[normalizedCode] ?? normalizedCode;
};
